// import 'virtual:svg-icons-register'
import '../css/app.css'
import * as Turbo from '@hotwired/turbo'
import { Application } from '@hotwired/stimulus'
import { registerControllers } from 'stimulus-vite-helpers'
import { showToast, initCustomFeatures } from './components/custom'
// import './services/rollbar'

// default
import 'lite-youtube-embed'
import 'lite-vimeo-embed/module/lite-vimeo-embed'

import.meta.glob('../img/**/*', { as: 'url', eager: true })
const controllers = import.meta.glob('./controllers/*_controller.ts', { eager: true })


const application = Application.start()
registerControllers(application, controllers)

Turbo.start()

function ensureSpriteExists({ spriteId, spriteUrl }) {
  const existing = document.getElementById(spriteId)

  if (existing) {
    //console.log('sprite exists')
    return
  }
  //console.log('sprite does not exist')
  const script = document.createElement('script')
  script.type = 'module'
  script.src = `${spriteUrl}`
  document.body.insertBefore(script, document.body.childNodes[0])
}

document.addEventListener('turbo:load', () => {

  const anchor = getAnchor(window.location)
  if (anchor) {
    const element = document.getElementById(anchor)
    element && element.scrollIntoView()
  }

  ensureSpriteExists(window.APP.CONFIG ?? {
    spriteId: 'vite-plugin-svg-spritemap',
    spriteUrl: '/svg/sprite.svg',
  })

  //Call custom function
  initCustomFeatures()
  showToast('Page loaded!')
})

document.addEventListener('turbo:click', () => {
  if (document.activeElement) {
    (document.activeElement as HTMLElement).blur()
  }
})



function getAnchor(url: Location) {
  let anchorMatch
  if (url.hash) {
    return url.hash.slice(1)
  } else if (anchorMatch = url.href.match(/#(.*)$/)) {
    return anchorMatch[1]
  } else {
    return false
  }
}


//Required because we set isolatedModules to true in tsconfig as per vite recommendation
//https://vitejs.dev/guide/features.html#isolatedmodules

//Community Popup
function initCommunityPopup() {
    //console.log("Community Modal Initialized (Turbo Compatible)");

    // Cache elements
    const $modal = $('#modalc');
    if (!$modal.length) return; // ✅ guard
    const $background = $('#modal-bgc');
    const $closeBtn = $('#modal-close-btn');
    const $contentWrapper = $('#modal-content-wrapper');

    let isOpen = false;
    let openScrollPosition = 0;

    function openModal(contentId) {
        if (isOpen) return;

        openScrollPosition = $(window).scrollTop();

        $modal.removeClass('hidden');
        $background.animate({ opacity: 0.6 }, 5);
        $('body').addClass('overflow-hidden');
        $(".communitySubscribe").addClass("active");

        isOpen = true;
    }

    function closeModal() {
        if (!isOpen) return;

        $background.animate({ opacity: 0 }, 200, function () {
            $modal.addClass('hidden');
            $(".communitySubscribe").removeClass("active");
        });

        $('body').removeClass('overflow-hidden');
        $(window).scrollTop(openScrollPosition);
        isOpen = false;
    }

    // Unbind first to avoid multiple bindings on Turbo visits
    /*$(document).off("click.modalTrigger");
    $(document).off("keydown.modalKey");

    $background.off("click").on("click", closeModal);
    $closeBtn.off("click").on("click", closeModal);

    $(document).on("keydown.modalKey", function (e) {
        if (e.key === "Escape" && isOpen) closeModal();
    });

    $(document).on("click.modalTrigger", "[data-modal-trigger]", function (e) {
        e.preventDefault();
        openModal($(this).data("modal-trigger"));
    });*/

    $(document)
        .off('click.communityPopup')
        .on('click.communityPopup', '[data-community-popup]', function (e) {
            e.preventDefault();
            openModal();
        });

    $background.off('click.communityPopup').on('click.communityPopup', closeModal);
    $closeBtn.off('click.communityPopup').on('click.communityPopup', closeModal);
}

//Community Past Archive Popup
function initCommunityPastArchivePopup() {
    //console.log("Community Modal Initialized (Turbo Compatible)");

    // Cache elements
    const $modal = $('#modalca');
    if (!$modal.length) return; // ✅ guard
    const $background = $('#modal-bgca');
    const $closeBtn = $('#modal-close-btn-ca');
    const $contentWrapper = $('#modal-content-wrapper');

    let isOpen = false;
    let openScrollPosition = 0;

    function openModal(contentId) {
        if (isOpen) return;

        openScrollPosition = $(window).scrollTop();

        $modal.removeClass('hidden');
        $background.animate({ opacity: 0.6 }, 5);
        $('body').addClass('overflow-hidden');
        $(".communityPastArchive").addClass("active");

        isOpen = true;
    }

    function closeModal() {
        if (!isOpen) return;

        $background.animate({ opacity: 0 }, 200, function () {
            $modal.addClass('hidden');
            $(".communityPastArchive").removeClass("active");
        });

        $('body').removeClass('overflow-hidden');
        $(window).scrollTop(openScrollPosition);
        isOpen = false;
    }

    // Unbind first to avoid multiple bindings on Turbo visits
    /*$(document).off("click.modalTrigger");
    $(document).off("keydown.modalKey");

    $background.off("click").on("click", closeModal);
    $closeBtn.off("click").on("click", closeModal);

    $(document).on("keydown.modalKey", function (e) {
        if (e.key === "Escape" && isOpen) closeModal();
    });

    $(document).on("click.modalTrigger", "[data-modal-trigger]", function (e) {
        e.preventDefault();
        openModal($(this).data("modal-trigger"));
    });*/

    // ✅ unique namespace + trigger
    $(document)
        .off('click.communityArchivePopup')
        .on('click.communityArchivePopup', '[data-community-archive-popup]', function (e) {
            e.preventDefault();
            openModal();
        });

    $background.off('click.communityArchivePopup').on('click.communityArchivePopup', closeModal);
    $closeBtn.off('click.communityArchivePopup').on('click.communityArchivePopup', closeModal);
}

function onPageLoad() {
    initCommunityPopup();
    initCommunityPastArchivePopup();
    showToast('Page loaded!');
    // add more here
}

document.addEventListener("DOMContentLoaded", onPageLoad);
document.addEventListener("turbo:load", onPageLoad);

//document.addEventListener("DOMContentLoaded", initCommunityPopup);
//document.addEventListener("turbo:load", initCommunityPopup);


// No export needed since it's self-contained